export default __webpack_public_path__ + "static/media/students-tinder-app-animation.75647630.mp4";